export enum ApiModuleEnum {
  INTEGRATION               = 'integration',
  ALARMS                    = 'alarm',
  AUTHORIZATION_PROCESS     = 'authorization_process',
  BASE                      = 'base',
  BREACH_REPORT             = 'breach_report',
  COLLECTION_PROCESS        = 'collection_process',
  MANAGEMENT                = 'management',
  LEGAL_COVERAGE            = 'legal_coverage',
  DEBTOR                    = 'debtor',
  DAMAGE_AND_MISSING_REPORT = 'damage_and_missing_report',
  DATABASE_QUERY            = 'database_query',
  FINANCIAL_INDICATORS      = 'financial_indicators',
  GATEWAY                   = 'gateway',
  LEGAL_PROCESS             = 'legal_process',
  NOTIFICATION              = 'notification',
  PAYMENT_AGREEMENT         = 'payment_agreement',
  PUBLIC_SERVICES_REPORT    = 'public_services_report',
  REPORTS                   = 'reports',
  USER                      = 'user',
  CLIENT                    = 'client',
  COLLECTION_SCORE          = 'collection_score',
  RESTRUCTURING_PROCESS     = 'restructuring_process',
  EMAIL_TRACKING             = 'email_tracking',
  PAYMENT                    = 'payment',
  PAYMENT_PROVISION          = 'payment_provision'
}
